export const bootcampsData = {
  dsa: {
    heading: 'Learn Data structure and Algorithms',
    subheading: 'Master the DSA skills with',
    highlightedSubheading: '200+ questions',
    explore: '/dsa-bootcamp',
    isLoggedIn: '/paid-bootcamp/DSA',
    isLoggedOut: '/login?redirect=/paid-bootcamp/DSA',
    price: 5000,
    discount: 20,
    starting: '15-Jan-2024',
    duration: '2 Months'
  },
  frontend: {
    heading: 'Become a Frontend Developer',
    subheading: 'Master your skills in Web:',
    highlightedSubheading: 'HTML, CSS, Javascript, React, Next and Typescript',
    explore: '/frontend-bootcamp',
    isLoggedIn: '/paid-bootcamp/Frontend',
    isLoggedOut: '/login?redirect=/paid-bootcamp/Frontend',
    price: 5000,
    discount: 20,
    starting: '15-Jan-2024',
    duration: '2 Months'
  },
  backend: {
    heading: 'Become a Job Ready Backend Developer',
    subheading: 'Learn Backend from industry expert for the',
    highlightedSubheading: 'next 4 months',
    explore: '/backend-bootcamp',
    isLoggedIn: '/paid-bootcamp/Backend',
    isLoggedOut: '/login?redirect=/paid-bootcamp/Backend',
    price: 5000,
    discount: 20,
    starting: '15-Jan-2024',
    duration: '2 Months'
  },
  fullstack: {
    heading: 'Become a Job Rady Full-Stack Developer',
    subheading: 'Learn DSA, Frontend and Backend from industry expert for the',
    highlightedSubheading: 'next 10 months',
    explore: '/10months-bootcamp',
    isLoggedIn: '/paid-bootcamp/10 Months Bootcamp',
    isLoggedOut: '/login?redirect=/paid-bootcamp/10 Months Bootcamp',
    price: 5000,
    discount: 20,
    starting: '15-Jan-2024',
    duration: '2 Months'
  }
} as const

export type BootcampsType = keyof typeof bootcampsData
